module.exports = __webpack_public_path__ + "static/media/avatar.2f5a6bcb.png";